<template>
  <div>
    <v-progress-linear class="my-0" background-opacity="0" :indeterminate="isLoading" :value="uploadProgress"></v-progress-linear>
    <v-container grid-list-xl>
      <v-layout column>
        <!-- Upload -->
        <v-flex>
          <file-uploader></file-uploader>
        </v-flex>
        <!-- Griglia -->
        <v-flex>
          <history-table></history-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapState } from "vuex";
import FileUploader from "./FileUploader";
import HistoryTable from "./HistoryTable";

export default {
  data: () => ({}),
  components: {
    FileUploader,
    HistoryTable
  },
  created() {
    // this.$vuetify.lang.current = this.$i18n.locale = 'de'
  },
  computed: {
    ...mapState({
      isLoading: state => state.common.pendingCalls > 0,
      uploadInProgress: state => state.files.uploadInProgress,
      uploadProgress: state => state.files.uploadProgress
    })
  }
};
</script>

<style>
</style>
